<p-toast></p-toast>
<p-confirmDialog #cd [style]="{width: '50vw'}">
    <ng-template pTemplate="footer">
        <button type="button" pButton icon="pi pi-times" label="No" (click)="cd.reject()"></button>
        <button type="button" pButton icon="pi pi-check" label="Si" (click)="cd.accept()"></button>
    </ng-template>
</p-confirmDialog>

<section class="card">
    <h2 style="text-align: center;">Administración de Usuarios</h2>

    <form [formGroup]="busquedaForm" (submit)="onSubmitBusqueda()" class="p-fluid ">
        <div class="grid">
            <div class="field col-12 md:col-4">
                <input pInputText type="text" placeholder="Buscar usuario"
                    class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                    formControlName="usuario" />
            </div>
        </div>

        <div class="grid">
            <div class="field col-12 md:col-4">
                <input id="firstname" pInputText type="text"
                    class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                    placeholder="Nombre" formControlName="nombre" />
            </div>
            <div class="field col-12 md:col-4">
                <input id="lastname1" pInputText type="text"
                    class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                    placeholder="Apellido Paterno" formControlName="apellido_paterno" />
            </div>
            <div class="field col-12 md:col-4">
                <input id="lastname2" pInputText type="text"
                    class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                    placeholder="Apellido Materno" formControlName="apellido_materno" />
            </div>
            
        </div>
        <div class="grid justify-content-end">
            <div class="busqueda-acciones">
                <button pButton type="submit" icon="pi pi-search"
                    class="p-button-rounded p-button-success p-button-text p-button-raised "></button>
            </div>
        </div>
            
    </form>

    <div class="flex justify-content-between align-items-center mb-4"></div>

    <!-- ✅ ÚNICO CAMBIO: usuarioPage → usuariosPage -->
    <p-table [value]="usuariosPage" [tableStyle]="{ 'min-width': '50rem' }">
        <ng-template pTemplate="header">
            <tr>
                <th colspan="8" class="text-center">Usuarios</th>
            </tr>
            <tr>
                <th>Nombre Usuario</th>
                <th>Sesion Usuario</th>
                <th>Alias</th>
                <th>Rol</th>
                <th>Nivel</th>
                <th colspan="3" style="text-align: center;">Acciones</th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-usuario>
            <tr [class.text-red-500]="usuario.activo == 0">
                <td>
                    <span [class.linea-texto]="usuario.activo == 0">
                        {{usuario.nom_completo | uppercase}}
                    </span>
                </td>
                <td>
                    <span [class.linea-texto]="usuario.activo == 0">
                        {{usuario.usuario}}
                    </span>
                </td>
                <td>
                    <span [class.linea-texto]="usuario.activo == 0">
                        {{usuario.alias}}
                    </span>
                </td>
                <td>
                    <span [class.linea-texto]="usuario.activo == 0">
                        {{usuario.rol?.descripcion}}
                    </span>
                </td>
                <td>
                    <span [class.linea-texto]="usuario.activo == 0">
                        {{usuario.fk_nivel}}
                    </span>
                </td>
                <td>
                    <a *ngIf="usuario.medico || usuario.enfermera || usuario.supervisor; else sinActualizacion" href="javascript:void(0)" (click)="actualizarUsuario(usuario)">
                        <i class="pi pi-pencil"></i>
                    </a>
                    <ng-template #sinActualizacion>
                        <span>-</span>
                    </ng-template>
                </td>
                <td>
                    <a href="javascript:void(0)" (click)="confirmacion(usuario)">
                        <li class="pi " [class.pi-play]="usuario.activo === 0" [class.pi-pause]="usuario.activo === 1">
                        </li>
                    </a>
                </td>
                <td>
                    <a href="javascript:void(0)" (click)="cambiarPassword(usuario)">
                        <li class="pi pi-user-edit"></li>
                    </a>
                </td>
            </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="8" class="text-center p-4">
                    <div class="flex flex-column align-items-center">
                        <i class="pi pi-inbox text-600" style="font-size: 2rem"></i>
                        <span class="text-600 mt-2">No se encontraron usuarios</span>
                    </div>
                </td>
            </tr>
        </ng-template>
    </p-table>

    <div class="card flex justify-content-center">
        <p-paginator (onPageChange)="onPageChange($event)" [first]="first" [rows]="rows"
            [totalRecords]="totalRecords"></p-paginator>
    </div>

    <!-- Modal de confirmación -->
    <div class="modal" *ngIf="showModalPassword">
        <div class="modal-content">
            <section>
                <h4 style="text-align: center;">Cambiar contraseña</h4>
                <form id="catalogo" [formGroup]="passwordForm" (submit)="onSubmitPassword()">
                    <div class="">
                        <input pInputText type="password" placeholder="Nueva contraseña"
                            class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                            formControlName="nuevo_password"
                            [ngClass]="{'ng-invalid ng-dirty': f['nuevo_password'].touched && f['nuevo_password'].invalid}" />
                        <small class="p-error"
                            *ngIf="f['nuevo_password'].touched && f['nuevo_password'].errors?.['required']">
                            La contraseña es requerida
                        </small>
                    </div>
                </form>
            </section>

            <div class="modal-buttons">
                <button type="submit" form="catalogo" [disabled]="!passwordForm.valid"
                    class="btn-confirm">Confirmar</button>
                <button type="button" (click)="cancelarAccion()" class="btn-cancel">Cancelar</button>
            </div>
        </div>
    </div>
</section>